
let baseUrl="http://36.144.72.178:8899/gisData/models/TH";

//无人机
// baseUrl="http://111.22.73.72:8081/gisData/models/TH" 
let model="feiji";
export function getModelUrl(key){
    //交通运输部南海第一救助飞行队+S-76D+988567
    key=key || ""
    let arr=key.split("+");
    if(arr && arr.length>1){
        model=arr[1];
    }
    return `${baseUrl}/${model}.glb`
}


let img="钻石DA40D";
export function getImageUrl(key){
    //交通运输部南海第一救助飞行队+S-76D+988567
    key=key || ""
    let arr=key.split("+");
    if(arr && arr.length>1){
        img=arr[1];
    }
    return `${baseUrl}/${img}.png`
}